// app/redux/sagas/leaveBalanceSaga.js

import { call, put } from "redux-saga/effects";

import {
    setLeaveBalanceLoading,
    checkBalanceSuccess,
    checkBalanceFail,
    getUserSoldesSuccess,
    getUserSoldesFail, cancelLeaveRequestSuccess, cancelLeaveRequestFail,
    getAllMovementsSuccess,
    getAllMovementsFail,
    getUserMovementsSuccess,
    getUserMovementsFail,
    getAllCompanySoldesSuccess,
    getAllCompanySoldesFail,
    updateSoldeSuccess,
    updateSoldeFail,
    GET_ALL_COMPANY_SOLDES_REQUEST,
    GET_ALL_MOVEMENTS_REQUEST,
} from "../actions/leaveBalanceActions";

import {API_BASE_URL, getRequest, patchRequest, postRequest} from "../../../api";
import {GET_MY_LEAVE_REQUESTS_REQUEST, setLeaveRequestLoading} from "../actions/leaveRequestsActions";
import Swal from "sweetalert2";

const extractErrorMessage = (error, fallback) => {
    const data = error?.response?.data;
    if (data?.message) return String(data.message);
    if (data?.error) return String(data.error);
    if (error?.message) return String(error.message);
    try {
        if (data && typeof data === "object") return JSON.stringify(data);
    } catch {}
    return fallback;
};

// ===================== WORKERS =====================

/**
 * Vérifier la disponibilité du solde
 */
export function* checkBalanceSaga(action) {
    const { userId, absenceTypeId, duree, companyId } = action.payload || {};

    const url = `${API_BASE_URL}/api/leave-balance/check?userId=${userId}&absenceTypeId=${absenceTypeId}&duree=${duree}&companyId=${companyId}`;
    const token = sessionStorage.getItem("token");

    yield put(setLeaveBalanceLoading(true));
    try {
        const resp = yield call(getRequest, { url, token });
        yield put(checkBalanceSuccess(resp.data));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur vérification solde");
        yield put(checkBalanceFail(msg));
    } finally {
        yield put(setLeaveBalanceLoading(false));
    }
}

/**
 * Récupérer les soldes disponibles d'un utilisateur
 */
export function* getUserSoldesSaga(action) {
    const { userId, companyId } = action.payload || {};

    const url = `${API_BASE_URL}/api/soldes-conges/user/${userId}/available?companyId=${companyId}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setLeaveBalanceLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getUserSoldesSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement soldes");
        yield put(getUserSoldesFail(msg));
    } finally {
        yield put(setLeaveBalanceLoading(false));
    }
}
export function* cancelLeaveRequestSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const { requestId } = action.payload || {};
    const url = `${API_BASE_URL}/api/leave-requests/requests/${requestId}/cancel`;

    yield put(setLeaveRequestLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: {},
            headers: { uid },
        });

        yield put(cancelLeaveRequestSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Demande annulée",
            text: "Votre solde a été restauré",
            timer: 1800,
            showConfirmButton: false,
        });

        // Recharger les demandes pour mettre à jour la liste
        yield put({ type: GET_MY_LEAVE_REQUESTS_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur annulation demande");
        yield put(cancelLeaveRequestFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setLeaveRequestLoading(false));
    }
}

export function* getAllMovementsSaga() {
    const url = `${API_BASE_URL}/api/soldes-conges/history/all`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setLeaveBalanceLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getAllMovementsSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement historique des soldes");
        yield put(getAllMovementsFail(msg));
    } finally {
        yield put(setLeaveBalanceLoading(false));
    }
}

export function* getUserMovementsSaga(action) {
    const { userId } = action.payload || {};
    if (!userId || userId === "0" || userId === 0) return;

    const url = `${API_BASE_URL}/api/soldes-conges/history/user/${userId}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setLeaveBalanceLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getUserMovementsSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement historique des soldes");
        yield put(getUserMovementsFail(msg));
    } finally {
        yield put(setLeaveBalanceLoading(false));
    }
}

export function* getAllCompanySoldesSaga() {
    const url = `${API_BASE_URL}/api/soldes-conges`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setLeaveBalanceLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getAllCompanySoldesSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement soldes société");
        yield put(getAllCompanySoldesFail(msg));
    } finally {
        yield put(setLeaveBalanceLoading(false));
    }
}

export function* updateSoldeSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    const { id, data } = action.payload || {};
    const url = `${API_BASE_URL}/api/soldes-conges/${id}`;

    yield put(setLeaveBalanceLoading(true));
    try {
        const resp = yield call(patchRequest, { url, token, uid, data });
        yield put(updateSoldeSuccess(resp.data));
        yield put({ type: GET_ALL_COMPANY_SOLDES_REQUEST });
        yield put({ type: GET_ALL_MOVEMENTS_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur mise à jour solde");
        yield put(updateSoldeFail(msg));
    } finally {
        yield put(setLeaveBalanceLoading(false));
    }
}
